module.exports = __webpack_public_path__ + "img/horizontal_3_4_pp12_7042.eb94d985.png";